import { render, staticRenderFns } from "./terms-conditions.vue?vue&type=template&id=77aa8f24&"
import script from "./terms-conditions.vue?vue&type=script&lang=js&"
export * from "./terms-conditions.vue?vue&type=script&lang=js&"
import style0 from "./terms-conditions.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports